import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createPropertyValue } from 'redux/product'
import { Divider, Grid } from 'semantic-ui-react'
import ProductPropertyList from './ProductPropertyList'
import ProductPropertyWinDeltaTexts from './ProductPropertyWinDeltaTexts'

const mapStateToProps = (state, ownProps) => {
  const { importProduct } = state.product
  const { properties } = state.properties
  return { importProduct, properties }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      createPropertyValue,
    },
    dispatch
  )
}

class ProductProperties extends React.Component {
  static propTypes = {
    form: PropTypes.string.isRequired,
    product: PropTypes.object.isRequired,
    compareProduct: PropTypes.object,
    importProduct: PropTypes.object,
    properties: PropTypes.array.isRequired,
    createPropertyValue: PropTypes.func.isRequired,
  }

  render() {
    // props
    const { form, product, compareProduct, properties } = this.props
    return (
      <div className="ProductProperties">
        <Grid stackable relaxed>
          <Grid.Row>
            <Grid.Column computer={12} largeScreen={7} widescreen={7}>
              <Divider className="compact" />
              <ProductPropertyList
                {...{
                  form,
                  properties,
                  familyProperties: product.product_family_properties || [],
                }}
              />
            </Grid.Column>

            <Grid.Column
              computer={12}
              largeScreen={5}
              widescreen={5}
              className="unobtrusive">
              <ProductPropertyWinDeltaTexts
                {...{ product, compareProduct, form }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}

ProductProperties = connect(mapStateToProps, mapDispatchToProps)(
  ProductProperties
)
export default ProductProperties



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductProperties.jsx